import React from 'react'
import type { FooterLinkItem } from './types'

export default function FooterLinks({ links }: { links: FooterLinkItem[] }) {
    return (
        <ul>
            {links.map((link, index) => (
                <li key={index}>
                    <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href={link.href}
                    >
                        {link.text}
                    </a>
                </li>
            ))}
        </ul>
    )
}
